const React = require("react");
const ReactRedux = require('react-redux');
const createReactClass = require('create-react-class');
const actions = require('../_actions.js');
const constants = require('../constants/deployment.js');

const Deploy = require('./buttons/Deploy.jsx');
const LoadingBar = require('../components/LoadingBar.jsx');
const Log = require('./Log.jsx');
const DeployStatusBar = require('./DeploymentStatusBar.jsx');

const deployment = createReactClass({

	componentDidMount: function() {
		// if there's an error, we shouldn't try to be updating logs
		if (this.props.error) {
			return;
		}

		this.props.updateLogs();
	},

	componentDidUpdate: function(prevProps) {
		// if there's an error, we shouldn't try to be updating logs
		if (this.props.error) {
			return;
		}

		if (this.props.current_deploy_id !== prevProps.current_deploy_id) {
			this.props.updateLogs();
		} else if (!this.props.deploy_done) {
			setTimeout(() => {
				this.props.updateLogs();
			}, 3000);
		}
	},

	getLogContent: function() {
		if (typeof this.props.deploy_log === 'undefined') {
			return (
				<div>
					<DeployStatusBar />
					<div className="log-loading">
						<LoadingBar show />
					</div>
				</div>
			);
		}
		return (
			<div>
				<DeployStatusBar />
				<Log content={this.props.deploy_log} />
			</div>
		);
	},

	render: function() {
		let error = null;
		if (this.props.error) {
			error = (
				<div className="alert alert-danger">
					<div className="">
						{this.props.error}
					</div>
				</div>
			);
		}

		let logOutput = null;
		if (this.props.deploy_started) {
			logOutput = this.getLogContent();
		}

		return (
			<div className="section deployment">
				{error}
				<div className="deploy-btn-container">
					<Deploy sha={this.props.selected_release} />
				</div>
				{logOutput}
			</div>
		);
	}
});

const mapStateToProps = function(state) {
	const current = state.deployment.list[state.deployment.current_id] || {};
	return {
		current_deploy_id: state.deployment.current_id,
		deploy_started: constants.hasDeployStarted(current.state) || state.deployment.is_queuing,
		deploy_done: constants.isDeployDone(current.state),
		error: state.deployment.error,
		selected_release: state.git.selected_release,
		deploy_log: state.deployment.logs[state.deployment.current_id]
	};
};

const mapDispatchToProps = function(dispatch) {
	return {
		updateLogs: function() {
			dispatch(actions.getDeployLog());
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(deployment);
